import type { TransmissionTaskType } from './transmission/ITask'

const { VITE_OBUS_ENV, VITE_OBUS_REGION } = import.meta.env
const APP_ID = '120401'
const APP_KEY = '1360'
const IS_SINGLE_PAGE_APP = true

export const TrackConfig = {
  app_id: APP_ID,
  app_key: APP_KEY,
  region: VITE_OBUS_REGION,
  env: VITE_OBUS_ENV,
  is_single_page_app: IS_SINGLE_PAGE_APP,
}

export const OWORK_WEB_EVENT_GROUP = '120401'

export enum TrackEventMap {
  LOG_OUT = '0002',
  ENTERED_FAQ = '0004',
  SWITCHING_APPLICATION = '0006',
  BACK_TO_THE_OLD_NOTE = '0007',
  PERSONAL_CENTER_OPERATION = '0008',
  TRANSMISSION_PANEL_CLICK = '0009',
  SEARCH_FILE_OPERATION = '0010',
  NOTIFICATION_OPEN_SHARED_FILE = '0011',
  PULL_UP_DEVICE_FROM_SEARCH_COMPONENT = '0012',
  CERTIFICATE_REMINDER_OPERATION = '0013',
  CERTIFICATE_INSTALLATION_OPERATION = '0014',
  PULL_UP_DEVICE_BY_MANUAL_CONFIRM = '0015',
  PULL_UP_DEVICE_BY_PASSWORD = '0016',
  TRANSMISSION_OVERRUN_ALARM_NOTICE = 'transmission_overrun_alarm_notice',
  TRANSMISSION_TASK = 'transmission_task',
}

export enum TrackAppId {
  FILE_MANAGER = 'file',
  STICKY_NOTES = 'sticky-notes',
  GALLERY = 'gallery',
  MESSAGES = 'messages',
  CONTACTS = 'contacts',
  PRIVATE_SAFE_BOX = 'private_safe_box',
  RECORDER = 'recorder',
  CLOUD_STORAGE = 'cloud_storage',
  BROWSER = 'browser',
  FIND_DEVICE = 'find_device',
  HISTORY = 'history',
  TRANSFER_DOCK = 'transfer-dock',
  CLOUD_DOCUMENT = 'cloud-document',
}

// 因为埋点上报应用名称固定为中文，不受之后的国际化影响，所以单独以id做中文名的映射

export const menuAppChineseNameMap = new Map<TrackAppId, string>([
  [TrackAppId.FILE_MANAGER, '跨端文件'],
  [TrackAppId.STICKY_NOTES, '便签'],
  [TrackAppId.GALLERY, '相册'],
  [TrackAppId.MESSAGES, '短信'],
  [TrackAppId.CONTACTS, '联系人'],
  [TrackAppId.PRIVATE_SAFE_BOX, '私密保险箱'],
  [TrackAppId.RECORDER, '录音'],
  [TrackAppId.CLOUD_STORAGE, '云盘'],
  [TrackAppId.BROWSER, '浏览器'],
  [TrackAppId.FIND_DEVICE, '查找'],
  [TrackAppId.HISTORY, '历史数据'],
  [TrackAppId.TRANSFER_DOCK, '中转站'],
  [TrackAppId.CLOUD_DOCUMENT, '文档'],
])

export interface TransmissionTrackInfo {
  [key: string]: unknown
  transmission_type: TransmissionTaskType
  transmission_state: 'failed' | 'success'
  transmission_network_type: 'LAN' | 'WAN'
  transmission_file_size: string
  number_of_retries: number
  reason_for_failure: string
}
